import {
  lazy,
  useState,
  useEffect,
  ComponentType,
  LazyExoticComponent,
} from 'react';

import { useDynamicScript } from './useDynamicScript';

import { loadFederatedAssetFactory } from '@/utils/loadFederatedAssets';

type federatedComponentPromise = () => Promise<{
  default: ComponentType<unknown>;
}>;

const componentCache = new Map();

export function useFederatedComponent(remoteConfig: FederatedRemoteConfig) {
  const { remoteUrl, remoteName, remoteModule } = remoteConfig;
  const key = `${remoteUrl}-${remoteName}-${remoteModule}`;

  const [component, setComponent] = useState<LazyExoticComponent<
    ComponentType<unknown>
  > | null>(null);

  const { isScriptReadyToUse, hasErrorWithScript } =
    useDynamicScript(remoteUrl);

  useEffect(() => {
    setComponent(null);
  }, [key]);

  useEffect(() => {
    if (isScriptReadyToUse && !component) {
      const remoteComponent = lazy(
        loadFederatedAssetFactory(
          remoteName,
          remoteModule
        ) as unknown as federatedComponentPromise
      );

      componentCache.set(key, remoteComponent);
      setComponent(remoteComponent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [component, isScriptReadyToUse, key]);

  return { hasErrorWithScript, component };
}
